export default "__VITE_ASSET__Cq9D_aSj__"